import styled from '@emotion/styled';
import { Colors, Typography } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

export const Headline = styled.div`
  color: ${Colors.neutral800};
  width: 100%;
  ${Typography.subHeader5Bold};

  ${mediaQueries.tablet} {
    ${Typography.subHeader3Bold};
  }
`;
